<template>
  <a-modal :visible="visible" title="新增分类" @ok="submit" @cancel="cancel">
    <a-form :form="form">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题">
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请填写标题' }] }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="所属栏目"
      >
        <a-tree-select
          v-decorator="['partentId']"
          :treeData="$store.getters.resource.resource"
          :replaceFields="replaceFields"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
        <a-input
          v-decorator="[
            'sort',
            {
              initialValue: '1',
              rules: [{ required: true, message: '请填写排序' }]
            }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="是否在首页显示"
      >
        <a-select
          v-decorator="[
            'isDisplay',
            {
              initialValue: 'N',
              rules: [{ required: true, message: '请选择是否首页显示' }]
            }
          ]"
        >
          <a-select-option key="Y" value="Y">是</a-select-option>
          <a-select-option key="N" value="N">否</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="是否对外开放"
      >
        <a-radio-group
          v-decorator="[
            'externalShow',
            {
              initialValue: 'N',
              rules: [{ required: true, message: '请选择是否对外展示' }]
            }
          ]"
          name="externalShow"
        >
          <a-radio value="N">否</a-radio>
          <a-radio value="Y">是</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="LOGO上传"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-upload
          v-decorator="[
            'logo',
            {
              valuePropName: 'file',
              getValueFromEvent: uploadHead
            }
          ]"
          name="files"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :multiple="false"
          :action="uploadURL"
          :headers="headers"
        >
          <img
            v-if="form.getFieldValue('logo')"
            class="userHead"
            :src="form.getFieldValue('logo')"
            alt="userHead"
          />
          <div v-else>
            <a-icon type="plus" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import storage from "store";
import { USER_TOKEN } from "@/store/mutation-types";
import { save } from "@/api/base/tree/manager";

export default {
  data() {
    return {
      //modal
      visible: false,
      //form
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      //upload
      uploadURL: window._CONFIG["uploadURL"], //上传路径
      headers: { user_token: storage.get(USER_TOKEN) },
      //selectTree
      replaceFields: {
        children: "jtypes",
        title: "name",
        key: "id",
        value: "id"
      }
    };
  },

  methods: {
    //LOGO上传
    uploadHead({ file }) {
      if (file.status == "uploading") {
        return;
      }
      if (file.status == "done") {
        let path = file.response.result[0].filePath;
        return path;
      }
    },

    // 显示
    show() {
      this.visible = true;
    },

    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          save({ ...values }).then(res => {
            this.$notification[res.resultCode == 1 ? "success" : "error"]({
              message: res.message
            });

            // 成功
            if (res.resultCode == 1) {
              // 置空表单
              this.form.resetFields();

              // 关闭窗口
              this.visible = false;

              // 回调
              this.$emit("onAddOk");
            }
          });
        }
      });
    },

    cancel() {
      this.visible = false;
      this.form.resetFields();
    }
  }
};
</script>
<style></style>
